import React from "react";
export default class extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    var cls = 'material-icons';
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    }
    return /*#__PURE__*/React.createElement("span", {
      className: cls
    }, this.props.icon);
  }
}